export function ApiOutputItemStringInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <input
      className='m-0 h-auto w-full border-b !border-gray-300 bg-transparent px-2 py-1'
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
